// import close from "../assets/close.png";
// import { useAuth } from "../hooks/useAuth";
// import deleteIcon from "../assets/delete.png";
// import { useNavigate } from "react-router-dom";
// import { useEffect, useState } from "react";
// import { routes } from "../helpers/Routes";
// import Drawer from '@mui/material/Drawer';
// const CarritoCompras = ({ setOpenCart, openCart }) => {
//     const { cart, getCart, removeCart } = useProductos();
//     const [pagar, setPagar] = useState(false);
//     const navigate = useNavigate();

//     const { usuario } = useAuth();
//     const goToCheckout = () => {
//         setPagar(true);
//     }

//     useEffect(() => {
//         console.log({ cart, })
//         getCart();
//     }, [])

//     useEffect(() => {
//         if (pagar) {
//             navigate(routes.checkout);
//         }
//     }, [pagar])


//  function NameColor(item){
//     try {
//       const color = namer(item?.color)?.basic[0]?.name
//       return color
//     } catch (error) {
//       return item?.color
//     }
//   }
//     return (
//         <div className={""}>
//             <Drawer open={openCart} onClose={() => setOpenCart(false)}   anchor={"right"}>
//             <div style={{ width: "100%", overflow: "auto", padding: "10px" }}>
//                 {cart?.length <= 0 ? <p style={{marginTop: "30px", marginBottom: "30px"}}>No hay productos para mostrar</p> : ""}
//                 {cart?.map((producto, idx) => {
//                     const miniatura = typeof producto?.img === "string" ? JSON.parse(producto?.img) : producto?.img;
//                     return (
//                         <div key={idx} style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", justifyContent: "center", marginBottom: 40 }}>
//                             <img src={miniatura?.find(img => img.isPrimary == "true" || true)?.url?.secure_url || miniatura[0]?.url?.secure_url} width={150} />
//                             <p>{producto?.nombre}</p>
                            
//                             <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//                                 <p>{producto?.precio}</p>
//                                 <p>Cantidad: {producto?.cantidad}</p>
//                                 <p>Color: {NameColor(producto)}</p>
//                                 <button onClick={() => removeCart(producto?.id, usuario?.id_usuario, producto?.size, producto?.color)} style={{ background: "white", color: "black", paddingTop: 3, paddingBottom: 3, paddingLeft: 5, paddingRight: 5 }}>
//                                     <img src={deleteIcon} width={20} style={{ filter: "invert(1)" }} />
//                                 </button>
//                             </div>
//                         </div>
//                     )
//                 })}
//             </div>
//             <div>
//                 <button onClick={goToCheckout} style={{ background: "white", color: "black", width: "100%" }}>Ir a pagar</button>
//             </div>
//             </Drawer>
//         </div>
//     );
// }

// export default CarritoCompras;
import { useState, useEffect } from "react"
import styled from "styled-components"
import { motion, AnimatePresence } from "framer-motion"
import namer from 'color-namer';
import { useProductos } from "../hooks/useProductos";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';


// Helper function to get color name
function getColorName(item){
         try {
           const color = namer(item?.color)?.basic[0]?.name
           return color
         } catch (error) {
           return item?.color
        }
}

// Color scheme based on requirements
const colors = {
  primary: "#2c2e2d", // Dark background
  textColor: "#f0f5f9", // Ice white for text
  accent: "#00ff88", // Green for buttons and badge
  accentHover: "#00e67a", // Slightly darker green for hover states
  background: "#2c2e2d", // Same as primary
  backgroundLight: "#3c3e3d", // Slightly lighter version of primary
  error: "#ff4d4f",
}

// Styled Components
const Overlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
  backdrop-filter: blur(2px);
`

const Drawer = styled(motion.div)`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  max-width: 450px;
  height: 100vh;
  background-color: ${colors.primary};
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  flex-direction: column;

  @media (max-width: 500px) {
    max-width: 100%;
  }
`

const DrawerHeader = styled.div`
  padding: 20px;
  background-color: ${colors.primary};
  color: ${colors.textColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid ${colors.backgroundLight};
`

const Title = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: ${colors.textColor};
`

const Badge = styled(motion.span)`
  background-color: ${colors.accent};
  color: ${colors.primary};
  font-size: 0.75rem;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 12px;
  margin-left: 12px;
`

const CloseButton = styled(motion.button)`
  background: none;
  border: none;
  cursor: pointer;
  color: ${colors.textColor};
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
`

const ScrollContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background-color: ${colors.primary};

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${colors.primary};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.backgroundLight};
    border-radius: 4px;
    border: 2px solid ${colors.primary};
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background-color: ${colors.accent};
  }
`

const EmptyCartContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50vh;
  text-align: center;
  padding: 20px;
`

const EmptyCartIcon = styled(motion.div)`
  margin-bottom: 20px;
  color: ${colors.textColor};
  opacity: 0.7;
  font-size: 3rem;
`

const EmptyCartTitle = styled.h3`
  font-size: 1.25rem;
  text-align: center;
  font-weight: 600;
  margin: 0 0 12px;
  color: ${colors.textColor};
`

const EmptyCartText = styled.p`
  color: ${colors.textColor};
  opacity: 0.8;
  text-align: center;
  margin: 0 0 30px;
  line-height: 1.5;
`

const ProductList = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const ProductCard = styled(motion.div)`
  display: flex;
  gap: 16px;
  background-color: ${colors.backgroundLight};
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

const ImageContainer = styled.div`
  position: relative;
  height: 100px;
  width: 100px;
  border-radius: 8px;
  overflow: hidden;
  background-color: ${colors.primary};
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
`

const ProductImage = styled(motion.img)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const ProductDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

const ProductHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

const ProductName = styled.h3`
  font-weight: 600;
  margin: 0;
  font-size: 1.1rem;
  color: ${colors.textColor};
`

const DeleteButton = styled(motion.button)`
  background: none;
  border: none;
  cursor: pointer;
  color: ${colors.textColor};
  opacity: 0.7;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  
  &:hover {
    opacity: 1;
    color: ${colors.error};
  }
`

const ProductMeta = styled.div`
  margin-top: 8px;
  font-size: 0.875rem;
  color: ${colors.textColor};
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

const MetaItem = styled(motion.span)`
  background-color: ${colors.primary};
  padding: 4px 10px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  color: ${colors.textColor};
`

const ProductFooter = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
`

const Price = styled.div`
  font-weight: 600;
  font-size: 1.1rem;
  color: ${colors.textColor};
`

const QuantityControl = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: ${colors.primary};
  padding: 4px;
  border-radius: 6px;
`

const QuantityButton = styled(motion.button)`
  background: none;
  border: none;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${colors.textColor};
  border-radius: 4px;
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

const QuantityText = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  min-width: 24px;
  text-align: center;
  color: ${colors.textColor};
`

const CartFooter = styled.div`
  border-top: 1px solid ${colors.backgroundLight};
  background-color: ${colors.primary};
  padding: 20px;
`

const TotalRow = styled(motion.div)`
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  font-size: 1.2rem;
  color: ${colors.textColor};
  padding: 12px 0;
`

const ButtonContainer = styled.div`
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

// Fixed Button component using $-prefixed props to prevent them from being passed to the DOM
const Button = styled(motion.button)`
  width: 100%;
  padding: 14px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  border: none;
  
  ${(props) =>
    props.$variant === "primary" &&
    `
    background-color: ${colors.accent};
    color: ${colors.primary};
  `}
  
  ${(props) =>
    props.$variant === "secondary" &&
    `
    background-color: transparent;
    border: 2px solid ${colors.accent};
    color: ${colors.accent};
  `}
`

// Icon components
const ShoppingBagIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: "10px" }}
  >
    <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <path d="M16 10a4 4 0 0 1-8 0"></path>
  </svg>
)

const TrashIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
    <line x1="10" y1="11" x2="10" y2="17"></line>
    <line x1="14" y1="11" x2="14" y2="17"></line>
  </svg>
)

const XIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="#000"
    stroke="#000"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
)

const EmptyCartSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="9" cy="21" r="1"></circle>
    <circle cx="20" cy="21" r="1"></circle>
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
    <line x1="4" y1="8" x2="20" y2="8"></line>
    <line x1="9" y1="12" x2="15" y2="12"></line>
  </svg>
)

// Animation variants
const drawerVariants = {
  hidden: { x: "100%" },
  visible: {
    x: 0,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 30,
      when: "beforeChildren",
      staggerChildren: 0.1,
    },
  },
  exit: {
    x: "100%",
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 30,
      when: "afterChildren",
      staggerChildren: 0.05,
      staggerDirection: -1,
    },
  },
}

const overlayVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 },
}

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 300, damping: 30 },
  },
  exit: {
    opacity: 0,
    x: -100,
    transition: { duration: 0.2 },
  },
  removed: {
    opacity: 0,
    x: 100,
    transition: { duration: 0.5 },
  },
}

const buttonVariants = {
  rest: { scale: 1 },
  hover: { scale: 1.05 },
  tap: { scale: 0.95 },
}

const iconButtonVariants = {
  rest: { backgroundColor: "rgba(0, 0, 0, 0)" },
  hover: { backgroundColor: "rgba(255, 255, 255, 0.1)" },
  tap: { scale: 0.9 },
}

const badgeVariants = {
  initial: { scale: 0 },
  animate: { scale: 1, transition: { type: "spring", stiffness: 500, damping: 30 } },
}

const emptyCartVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 30,
      when: "beforeChildren",
      staggerChildren: 0.2,
    },
  },
}

const emptyCartIconVariants = {
  hidden: { opacity: 0, y: -20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 15,
      repeat: Number.POSITIVE_INFINITY,
      repeatType: "reverse",
      repeatDelay: 2,
    },
  },
}

export default function ShoppingCart({ setOpenCart, openCart }) {
  const [removingId, setRemovingId] = useState(null)
  const { cart, getCart, removeCart, formatoCOP, productos } = useProductos();


  const updateQuantity = (id, newQuantity) => {
    if (newQuantity < 1) return

    // setCart((prev) => prev.map((item) => (item.id === id ? { ...item, cantidad: newQuantity } : item)))
  }
  const handleClose = () => {
    setOpenCart(false)
  }

  const goToCheckout = () => {
    // Use window.location instead of Next.js router
    window.location.href = "/checkout"
  }

  const handleRemoveItem = (id, userId, size, color) => {
    setRemovingId(id)
    // Delay actual removal to allow animation to complete
      removeCart(id, userId, size, color)
      setRemovingId(null)
  }
  useEffect(() => {
      
  }, [cart])

  useEffect(() => {
    getCart()

    // Prevent body scrolling when cart is open
    if (openCart) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "auto"
    }

    return () => {
      document.body.style.overflow = "auto"
    }
  }, [])

  // Calculate total price
  const totalPrice =
    cart?.reduce((total, product) => {
      return total + (Number.parseFloat(product?.price) * product?.cantidad || 0)
    }, 0) || 0

  return (
    <AnimatePresence>
      {openCart && (
        <>
          <Overlay variants={overlayVariants} initial="hidden" animate="visible" exit="exit" onClick={handleClose} />
          <Drawer variants={drawerVariants} initial="hidden" animate="visible" exit="exit">
            <DrawerHeader>
              <Title>
                <ShoppingBagIcon />
                    Tu carrito de compras
                <AnimatePresence>
                  {cart?.length > 0 && (
                    <Badge variants={badgeVariants} initial="initial" animate="animate" key="badge">
                      {cart.length} {cart.length === 1 ? "producto" : "productos"}
                    </Badge>
                  )}
                </AnimatePresence>
              </Title>
              <CloseButton
                onClick={handleClose}
                variants={iconButtonVariants}
                initial="rest"
                whileHover="hover"
                whileTap="tap"
              >
                <XIcon/>
              </CloseButton>
            </DrawerHeader>

            <ScrollContainer>
              <AnimatePresence mode="wait">
                {!cart || cart.length <= 0 ? (
                  <EmptyCartContainer key="empty" variants={emptyCartVariants} initial="hidden" animate="visible">
                    <EmptyCartIcon variants={emptyCartIconVariants}>
                      <EmptyCartSvg />
                    </EmptyCartIcon>
                    <motion.div variants={itemVariants}>
                      <EmptyCartTitle>Tu carrito está vacío</EmptyCartTitle>
                    </motion.div>
                    <motion.div variants={itemVariants}>
                      <EmptyCartText>
                        No tienes Productos en el carrito
                      </EmptyCartText>
                    </motion.div>
                    <motion.div variants={itemVariants}>
                      <Button
                        $variant="secondary"
                        onClick={handleClose}
                        variants={buttonVariants}
                        initial="rest"
                        whileHover="hover"
                        whileTap="tap"
                      >
                        Continuar comprando
                      </Button>
                    </motion.div>
                  </EmptyCartContainer>
                ) : (
                  <ProductList key="list" variants={itemVariants} initial="hidden" animate="visible">
                    <AnimatePresence>
                      {cart?.map((producto, idx) => {
                        console.log(producto)
                        const imageUrl = producto.image?.pathname


                        return (
                          <ProductCard
                            key={producto.id}
                            variants={itemVariants}
                            initial="hidden"
                            animate={removingId === producto.id ? "removed" : "visible"}
                            exit="exit"
                            layout
                          >
                            <ImageContainer>
                              <ProductImage
                                src={imageUrl || "/placeholder.svg"}
                                alt={producto?.name || "Product image"}
                                whileHover={{ scale: 1.05 }}
                                transition={{ type: "spring", stiffness: 300, damping: 30 }}
                              />
                            </ImageContainer>

                            <ProductDetails>
                              <ProductHeader>
                                <ProductName>{producto?.name}</ProductName>
                                <DeleteButton
                                  onClick={() =>
                                    handleRemoveItem(producto?.id, undefined, producto?.size, producto?.color)
                                  }
                                  aria-label="Remove item"
                                  variants={iconButtonVariants}
                                  initial="rest"
                                  whileHover="hover"
                                  whileTap="tap"
                                >
                                  <DeleteOutlineIcon  />
                                </DeleteButton>
                              </ProductHeader>

                              <ProductMeta>
                                {producto?.size && (
                                  <MetaItem
                                    whileHover={{ scale: 1.05 }}
                                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                                  >
                                    Tamaño: {producto.size}
                                  </MetaItem>
                                )}
                                
                                {producto?.color && (
                                  <MetaItem
                                    whileHover={{ scale: 1.05 }}
                                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                                  >
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "12px",
                                        height: "12px",
                                        backgroundColor: producto.color,
                                        borderRadius: "50%",
                                        marginRight: "6px",
                                        border: "1px solid rgba(255,255,255,0.2)",
                                      }}
                                    ></span>
                                    {getColorName(producto)}
                                  </MetaItem>
                                )}
                                  {producto?.cantidad && (
                                  <MetaItem
                                    whileHover={{ scale: 1.05 }}
                                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                                  >
                                    {producto.cantidad}
                                  </MetaItem>
                                )}
                              </ProductMeta>

                              <ProductFooter>
                                <Price>{formatoCOP.format(producto.price)}</Price>
                                {/* <QuantityControl>
                                  <QuantityButton
                                    onClick={() => updateQuantity(producto.id, producto.cantidad - 1)}
                                    disabled={producto.cantidad <= 1}
                                    variants={iconButtonVariants}
                                    initial="rest"
                                    whileHover="hover"
                                    whileTap="tap"
                                  >
                                    <MinusIcon />
                                  </QuantityButton>
                                  <QuantityText>{producto.cantidad}</QuantityText>
                                  <QuantityButton
                                    onClick={() => updateQuantity(producto.id, producto.cantidad + 1)}
                                    variants={iconButtonVariants}
                                    initial="rest"
                                    whileHover="hover"
                                    whileTap="tap"
                                  >
                                    <PlusIcon />
                                  </QuantityButton>
                                </QuantityControl> */}
                              </ProductFooter>
                            </ProductDetails>
                          </ProductCard>
                        )
                      })}
                    </AnimatePresence>
                  </ProductList>
                )}
              </AnimatePresence>
            </ScrollContainer>

            <AnimatePresence>
              {cart?.length > 0 && (
                <CartFooter key="footer">
                  <TotalRow initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>
                    <span>Total</span>
                    <motion.span
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1 }}
                      transition={{
                        type: "spring",
                        stiffness: 500,
                        damping: 30,
                        delay: 0.3,
                      }}
                    >
                      {formatoCOP.format(totalPrice)}
                    </motion.span>
                  </TotalRow>

                  <ButtonContainer>
                    <Button
                      $variant="primary"
                      onClick={goToCheckout}
                      variants={buttonVariants}
                      initial="rest"
                      whileHover="hover"
                      whileTap="tap"
                    >
                      Proceder a Pagar
                    </Button>
                    <Button
                      $variant="secondary"
                      onClick={handleClose}
                      variants={buttonVariants}
                      initial="rest"
                      whileHover="hover"
                      whileTap="tap"
                    >
                      Continuar Comprando
                    </Button>
                  </ButtonContainer>
                </CartFooter>
              )}
            </AnimatePresence>
          </Drawer>
        </>
      )}
    </AnimatePresence>
  )
}

